import * as R from 'ramda';

import { authenticatedApiFetch } from '../../common/helpers';
import { mapLendersFromJson, mapTransactionsFromJson, mapTransactionSummaryFromJson } from './transactionMappers';
import { isLenderPortfolioApiEnabled } from '../../common/config';

export function toggleTransactionModal(action) {
  return action;
};

export function transactionModalDetail(content) {
  return content;
};

export async function getLenders() {
  return await authenticatedApiFetch('lender/profiles', 'GET')  
    .then(R.defaultTo([]))
    .then((res) => res.data ?? [])
    .then(R.map(mapLendersFromJson));
};

export async function getTransactions(params) {
  if (!isLenderPortfolioApiEnabled()) {
    return await authenticatedApiFetch('lender/transactions', 'GET', params)
      .then(({data, totalData}) => ({
        lists: R.map(mapTransactionsFromJson, data ?? []),
        summary: {},
        totalData
      }));
  }
  const pfParams = { lender_id: params?.lender_id };
  return await Promise.all([
    authenticatedApiFetch('lender/transactions', 'GET', params),
    authenticatedApiFetch('lender/portfolio', 'GET', pfParams)
  ]) 
    .then(([{data, totalData}, portfolio]) => {
      return {
        lists: R.map(mapTransactionsFromJson, data ?? []),
        summary: mapTransactionSummaryFromJson(portfolio),
        totalData
      }
    });
};

export function setLenderSelected(lenderId) {
  return lenderId;
}

export async function topup(detail) {
  const topupData = {
    amount: detail.amount,
    lender_id: detail.lender
  };
  return await authenticatedApiFetch('lender/topup', 'POST', topupData);
};

export async function withdraw(detail) {
  const withdrawData = {
    amount: detail.amount,
    lender_id: detail.lender
  };
  return await authenticatedApiFetch('lender/cashout', 'POST', withdrawData);
};

export function resetTransaction() {
  return true;
};
